// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2m1QD","containerItemsCenter":"Skeleton_containerItemsCenter__3Y7TM"};